import {
  HeaderWithBulletPoints,
  FormB1,
  TwoHeadersAndBulletPoints,
} from '@chegg-wt/core/types/core'

export const confirmContent: HeaderWithBulletPoints[] = [
  {
    header: 'What is the Purpose of This Page?',
    body: [
      "It has two purposes. First, this page is a reminder to check the information we've found and to make sure it matches what you see in your source. Second, it shows you what information was and was not found when we looked for information on your source.",
    ],
  },
  {
    header:
      'How Does This Work? Why Does This Feature Sometimes Not Find Citation Information?',
    body: [
      "When you choose to cite a source using our automatic citing feature (like books, website, journals, etc.), we search through other resources and databases for details about your source. If we find a match to what you are citing, we import as much citation detail as possible, but sometimes information is missing or not comprehensive. That is why we have this page; it's to ensure that you know what information may still need to be found or edited.",
    ],
  },
  {
    header: "What Happens if I Don't Know All of the Missing Information?",
    body: [
      "Input as much information as you can. Once a citation is created, you can go back and manually edit in the other details later. Also, some citation styles don't require all of the information we highlight on this page. You may want to check what is needed for your source's citation.",
      "For those with an EasyBib® account, if you don’t have all of the information at your fingertips, don't worry. You can always go back to your bibliography later to edit information in the citation form.",
    ],
  },
  {
    header: 'What Should I Do Next?',
    body: [
      "Go ahead and click 'Continue.' This will take you to a form that will help you build your citation. Anything we already found will be automatically inputted. Feel free to edit existing information (if you find it is not correct) and to add any missing information.",
    ],
  },
]

const formContent: TwoHeadersAndBulletPoints[] = [
  {
    header: 'Annotation',
    bodyHeader:
      'Additional notes or comments. For citations, annotations usually include a brief description of the content and what you think of it.',
  },
  {
    header: 'Date Accessed',
    bodyHeader:
      'Date (day, month, and/or year) the source was accessed or viewed online.',
  },
  {
    header: 'Electronically Published',
    bodyHeader:
      'When the source was electronically published. Sometimes, the date is not readily available.',
  },
  {
    header: 'Place of Publication',
    bodyHeader:
      'Name of the city, state or country where the publisher of a source is located. For written sources, this can usually be found on the title page. It is not always required, depending on the style.',
  },
  {
    header: 'Publisher or Sponsor',
    bodyHeader:
      'The organization, company, individual, or other entity that published, sponsored, or issued the content.',
  },
  {
    header: 'Suffix',
    bodyHeader:
      'In the citation forms, this refers to any additions to the end of a name that tells us more information about the contributor. Examples: Jr., Sr., II, III, Esq., etc.',
  },
  {
    header: 'Title',
    bodyHeader:
      'What a source is called or its name. In the absence of a title, some styles may ask for a summary of the source.',
  },
  {
    header: 'URL',
    bodyHeader:
      'The address of a web page. URL is short for Uniform Resource Locator. Example: www.citationmachine.net',
  },
  {
    header: 'Medium',
    bodyHeader:
      'Way the content or information is communicated, shared, or published. Below are examples for two source types.',
    body: [
      'E-book: Other: PDF, JPEG file, Powerpoint, etc.',
      'Painting/Artwork: Graphite on paper, Marble, Oil on canvas, etc.',
    ],
  },
  {
    header: 'Contributor',
    bodyHeader:
      'Person or organization that assisted in creating content, a performance, or a resource. Examples include a translator, book editor, screenwriter, singer, etc.',
  },
  {
    header: 'Author',
    bodyHeader:
      'Someone who was the originator and creator of content. An author is usually tied to written content (e.g. book, article, play, etc.), but sometimes relates to a digital image, comic, or podcast.',
  },
]

export const formB1: FormB1 = {
  header: 'Form Glossary',
  table: formContent,
}
